import React from 'react';
import { createPortal } from 'react-dom';

import useDropdown from 'Hooks/useDropdown';

import FilterIcon from 'Assets/icons/filter.svg';
import XMarkIcon from 'Assets/icons/xmark.svg';

export default function TableFilterModalThreeHandlers({
    children,
    noActions,
    onApply,
    onCancel = null,
    onProcess = null,
    showApply = true,
    showCancel = false,
    showProcess = false,
    customIconStyle = '',
    cancelText = null,
    applyText = null,
    processText = null,
    headerText = null,
    closeOnAction = true,
    contentMaxHeight = '60vh',
    isActive = false,
}) {
    const { triggerRef, dropdownRef, isOpen, close, toggle } = useDropdown();

    const onApplyClick = () => {
        if (closeOnAction) close();
        typeof onApply === 'function' && onApply();
    };

    const onCancelClick = () => {
        if (closeOnAction) close();
        typeof onCancel === 'function' && onCancel();
    };

    const onProcessClick = () => {
        if (closeOnAction) close();
        typeof onProcess === 'function' && onProcess();
    };

    return (
        <div>
            <button
                type="button"
                className={`table__icon-btn ${isActive ? '!tw-bg-green-500 !tw-border-green-500' : 'secondary'}
                ${customIconStyle}`}
                ref={triggerRef}
                onClick={toggle}
            >
                <FilterIcon className="tw-w-3.5 tw-h-3.5" />
            </button>
            {createPortal(
                <div className={`table__filter-modal${isOpen ? '' : ' hidden'}`} ref={dropdownRef} style={{ zIndex: 1000 }}>
                    <button type="button" className="table__filter-modal__close-btn" onClick={close}>
                        <span aria-hidden="true">
                            <XMarkIcon className="tw-w-2.5 tw-h-2.5" />
                        </span>
                    </button>
                    <div className="tw-pt-4 tw-px-4">
                        <div className="table__filter-modal__title">{headerText || $t('Filters')}</div>
                    </div>
                    <div className="tw-px-4 tw-pb-4 tw-overflow-y-auto" style={{ maxHeight: contentMaxHeight }}>
                        {children}
                    </div>
                    {!noActions && (
                        <div className="tw-flex tw-justify-end tw-px-2.5 tw-py-3">
                            {showCancel && (
                                <button type="button" className="tw-mr-2" onClick={() => onCancelClick()}>
                                    {cancelText || $t('Cancel')}
                                </button>
                            )}
                            {showProcess && (
                                <button type="button" className="tw-mr-2" onClick={() => onProcessClick()}>
                                    {processText || $t('Process')}
                                </button>
                            )}
                            {showApply && (
                                <button type="button" className="table__filter-modal__apply-btn" onClick={() => onApplyClick()}>
                                    {applyText ?? $t('Apply')}
                                </button>
                            )}
                        </div>
                    )}
                </div>,
                document.body,
            )}
        </div>
    );
}
